var _circle, _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg9 = function Svg9(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "url(#paint0_linear_906_536222)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7742 21H7.59417C5.72945 20.85 2 19.38 2 14.7C2 11.55 5.0625 9.3 7.25 9.3C7.25 7.95 9 3 14.25 3C17.75 3 19.5 5.25 20.5302 6.6C21.4335 6.15 23.875 6.15 25.1875 6.6C26.5 7.05 30 9.3 30 13.8C30 18.3 26.0625 21 22.7742 21Z",
    fill: "url(#paint1_linear_906_536222)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5983 28.5143C10.3311 28.6708 10.0042 28.6067 9.86815 28.371L9.11224 27.138L8.31119 28.3959C8.15894 28.6216 7.82823 28.6628 7.57253 28.4879C7.31683 28.313 7.23297 27.9883 7.38523 27.7626L8.15395 26.5554L6.49615 26.5556C6.22427 26.5485 6.01032 26.2928 6.01828 25.9846C6.02624 25.6764 6.25309 25.4323 6.52497 25.4395L8.07083 25.4393L7.2463 24.0944C7.11026 23.8588 7.21661 23.5409 7.48384 23.3844C7.75108 23.2279 8.078 23.2921 8.21404 23.5277L9.13031 25.0223L10.0825 23.527C10.2348 23.3013 10.5655 23.2601 10.8212 23.435C11.0769 23.6099 11.1607 23.9346 11.0085 24.1604L10.1941 25.4392L11.5399 25.439C11.8118 25.4462 12.0258 25.7018 12.0178 26.01C12.0099 26.3182 11.783 26.5623 11.5111 26.5551L10.0701 26.5553L10.8359 27.8043C10.9719 28.0399 10.8656 28.3578 10.5983 28.5143Z",
    fill: "#42A0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5983 28.5143C17.3311 28.6708 17.0042 28.6067 16.8681 28.371L16.1122 27.138L15.3112 28.3959C15.1589 28.6216 14.8282 28.6628 14.5725 28.4879C14.3168 28.313 14.233 27.9883 14.3852 27.7626L15.154 26.5554L13.4961 26.5556C13.2243 26.5485 13.0103 26.2928 13.0183 25.9846C13.0262 25.6764 13.2531 25.4323 13.525 25.4395L15.0708 25.4393L14.2463 24.0944C14.1103 23.8588 14.2166 23.5409 14.4838 23.3844C14.7511 23.2279 15.078 23.2921 15.214 23.5277L16.1303 25.0223L17.0825 23.527C17.2348 23.3013 17.5655 23.2601 17.8212 23.435C18.0769 23.6099 18.1607 23.9346 18.0085 24.1604L17.1941 25.4392L18.5399 25.439C18.8118 25.4462 19.0258 25.7018 19.0178 26.01C19.0099 26.3182 18.783 26.5623 18.5111 26.5551L17.0701 26.5553L17.8359 27.8043C17.9719 28.0399 17.8656 28.3578 17.5983 28.5143Z",
    fill: "#42A0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5983 28.5143C24.3311 28.6708 24.0042 28.6067 23.8681 28.371L23.1122 27.138L22.3112 28.3959C22.1589 28.6216 21.8282 28.6628 21.5725 28.4879C21.3168 28.313 21.233 27.9883 21.3852 27.7626L22.154 26.5554L20.4961 26.5556C20.2243 26.5485 20.0103 26.2928 20.0183 25.9846C20.0262 25.6764 20.2531 25.4323 20.525 25.4395L22.0708 25.4393L21.2463 24.0944C21.1103 23.8588 21.2166 23.5409 21.4838 23.3844C21.7511 23.2279 22.078 23.2921 22.214 23.5277L23.1303 25.0223L24.0825 23.527C24.2348 23.3013 24.5655 23.2601 24.8212 23.435C25.0769 23.6099 25.1607 23.9346 25.0085 24.1604L24.1941 25.4392L25.5399 25.439C25.8118 25.4462 26.0258 25.7018 26.0178 26.01C26.0099 26.3182 25.783 26.5623 25.5111 26.5551L24.0701 26.5553L24.8359 27.8043C24.9719 28.0399 24.8656 28.3578 24.5983 28.5143Z",
    fill: "#42A0F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_906_536222",
    x1: 3,
    y1: 2.5,
    x2: 15.375,
    y2: 14.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEB41C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_906_536222",
    x1: 6.91448,
    y1: 4.5068,
    x2: 24.7045,
    y2: 21.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg9, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/9.b4456e24.svg";
export { ForwardRef as ReactComponent };